import jwtDecode from "jwt-decode";

export const getEnvironment = () => {
    const url = global.window.location.href;
    if (url.includes("localhost")) {
        return null;
    } else if (url.includes("uat")) {
        return "uat";
    } else if (url.includes("integration")) {
        return "integration";
    } else {
        return "production";
    }
};

const tokenNameWithEnvironmentSuffix = () => {
    const environment = getEnvironment();
    return "token" + (environment ? "-" : "") + (environment ?? "");
};

const getCookie = () => {
    const tokenName = tokenNameWithEnvironmentSuffix();

    const name = `${tokenName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (const cookie of ca) {
        let ck = cookie;
        while (ck.startsWith(" ")) {
            ck = ck.substring(1);
        }
        if (ck.startsWith(name)) {
            return ck.substring(name.length, ck.length);
        }
    }
    return "";
};

export const getUserDetailsFromCookie = () => {
    const rawToken = getCookie();

    try {
        const emailAddressKey = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";
        const decoded = jwtDecode(rawToken);
        const userId = decoded.user;
        const emailAddress = decoded[emailAddressKey];
        return { userId, emailAddress, isSystemAdmin: decoded['is-system-admin'] };
    } catch {
        return null;
    }
};

export const setCookie = (cname, value, domain = window.location.host) => {
    document.cookie = `${cname}=${value};`;
    document.cookie = `domain=${domain};`;
};